module.exports = __webpack_public_path__ + "kusamaproject/img/default-icon.8f984d95.png";